import React, { useState, useEffect, useContext } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { NavLink, Link } from 'react-router-dom'
import { logo } from '../assets/images/Index.js'
import '../App.css'
import CartIcon from '../assets/images/cart.png'
import { CartContext } from '../context/CartContext.js'
import { isTokenExpired, logoutUser } from "../utils/auth";

export default function Navbar() {
  const [showAdminLink, setShowAdminLink] = useState(false);
  const { cart } = useContext(CartContext);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    const rolesData = localStorage.getItem("roles");

    if (userData) {
      try {
        const user = JSON.parse(userData);
        const roles = rolesData ? JSON.parse(rolesData).map(r => r.trim()) : [];

        const isAdmin = user.role === "Admin";
        const isPartner = user.role === "Partner";
        const hasManagementRole = roles.some(r =>
          r.toLowerCase().includes("management")
        );

        // ✅ Show Administration link for Admin, Partner, or any management role user
        setShowAdminLink(isAdmin || isPartner || hasManagementRole);

      } catch (error) {
        console.error("Error parsing user data:", error);
        setShowAdminLink(false);
      }
    } else {
      setShowAdminLink(false);
    }
  }, []);

  const username = localStorage.getItem("username");
  const token = localStorage.getItem("token");

  if (token && isTokenExpired(token)) {
    logoutUser();
    return null;
  }

  return (
    <div>
      <nav className="navbar rounded navbar-expand-lg bg-body-tertiary px-2">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={logo} className='' style={{ width: '10rem' }} />
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-between" id="navbarNav">
            <ul className="nav nav-underline mx-5 py-3 justify-content-center">
              <li className="nav-item mx-1">
                <NavLink className="nav-NavLink" to='/'>Home</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-NavLink" to='/about/'>About</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-NavLink" to="/contact/">Contact</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-NavLink" to="/jobs/">Jobs</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-NavLink" to="/package/">Packages</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-NavLink" to="/blog">Blog</NavLink>
              </li>

              {/* ✅ Show for Admin, Partner, or management role users */}
              {showAdminLink && (
                <li className="nav-item">
                  <NavLink className="nav-NavLink" to="/dashboard/">Administration</NavLink>
                </li>
              )}
            </ul>

            <ul className="nav nav-underline mx-5 py-3 justify-content-center">
              <li className="nav-item dropdown">
                {username ? (
                  <>
                    <span
                      className="fw-bold text-primary border border-primary py-2 px-4 rounded-1 dropdown-toggle"
                      role="button"
                      id="userDropdown"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {username.toUpperCase()}
                    </span>
                    <ul className="dropdown-menu mt-2" aria-labelledby="userDropdown">
                      <li>
                        <NavLink className="dropdown-item" to="/profile">
                          Profile
                        </NavLink>
                      </li>
                      <li>
                        <button
                          className="dropdown-item text-danger"
                          onClick={() => {
                            localStorage.removeItem("username");
                            localStorage.removeItem("user");
                            localStorage.removeItem("token");
                            localStorage.removeItem("roles");
                            window.location.href = "/";
                          }}
                        >
                          Logout
                        </button>
                      </li>
                    </ul>
                  </>
                ) : (
                  <NavLink className="nav-NavLink" to="/Login/">Login</NavLink>
                )}
              </li>

              <li className="nav-item position-relative">
                <NavLink className="nav-NavLink" to="/cart/">
                  <img src={CartIcon} alt="Cart" style={{ width: "25px" }} />
                  {cart.length > 0 && (
                    <span
                      className="badge bg-danger rounded-circle position-absolute"
                      style={{ top: "0", right: "-5px", fontSize: "0.7rem" }}
                    >
                      {cart.length}
                    </span>
                  )}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}